import { GatsbyImage } from "gatsby-plugin-image";
import styled, { css } from "styled-components";


export const Wrap = styled.div`
  text-align: center;
  position: relative;
  background: ${({ theme }) => theme.secondary.main};
`;

export const Frame = styled.div`
  ${props => props.wrapper && css`
    position: relative;
    display: flex;
    width: 100%;
  `}

  ${props => props.container && css`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    pointer-events: none;
  `}

  ${props => props.background && css`
    flex: 1;
    display: flex;
  `}

  ${props => props.text && css`
    margin-top: 15vh;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    vertical-align: bottom;

    @media only screen and (min-width: 2000px){
      margin-top: 20vh;
    }

    @media ${({ theme }) => theme.device.desktop}{
      margin-top: 5vh;
    }

    @media ${({ theme }) => theme.device.tablet}{
      margin-top: 20px;
    }

    @media ${({ theme }) => theme.device.tabletPortrait}{
      margin-top: 80px;
      margin-left: 8px;
      margin-right: 8px;
    }

    @media ${({ theme }) => theme.device.mobile}{
      margin-top: 20px;
      margin-left: 8px;
      margin-right: 8px;

    }

    @media ${({ theme }) => theme.device.phone}{
      margin-top: 20px;
      margin-left: 8px;
      margin-right: 8px;
      margin-bottom: auto;
    }
  `}
`;


export const Title = styled.h1`
  font-family: "Quantico", sans-serif;
  font-weight: 700;
  text-align: center;
  font-size: 42px;
  line-height: 52px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.text.primary};
  margin: 0 0 8px 0;
  padding: 8px 16px;
  background: rgba(255, 255, 255, 0.5);
  display: inline-block;

  @media ${({ theme }) => theme.device.mobile}{
    font-size: 18px;
    line-height: 21px;
    padding: 2px 4px;
    
  }
`

export const Description = styled.div`
  color: ${({ theme }) => theme.text.white};
  display: inline-block;
  padding: 8px;
  font-size: 18px;
  line-height: 21px;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  margin-bottom: 20px;
  background: ${({ theme }) => theme.primary.main}cc;

  @media only screen and (min-width: 1800px){
    margin-bottom: 20px;
    background: ${({ theme }) => theme.primary.main}cc;
  }

  @media ${({ theme }) => theme.device.tablet}{
    background: ${({ theme }) => theme.primary.main}cc;
    max-width: 620px;
    margin-bottom: 20px;
    font-size: 16px;
  }

  @media ${({ theme }) => theme.device.mobile}{
    background: ${({ theme }) => theme.primary.main}cc;
    max-width: 620px;
    margin-bottom: 20px;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: auto;
    padding: 2px;
  }
`;

export const PlayButton = styled.button`
  border: 0;
  background: ${({ theme }) => theme.thirdiary.main};
  border-radius: 50%;
  height: 80px;
  width: 80px;
  
  padding-left: 12px;
  fill: ${({ theme }) => theme.text.white};
  
  &:hover{
    background: ${({ theme }) => theme.thirdiary.dark};
  }

  @media ${({ theme }) => theme.device.mobile}{
    width: 60px;
    height: 60px;
    padding-left: 10px;
  }
`

export const Video = styled.video`
  max-height: 85vh;
  width: 100%;
  margin: auto;
`;

export const ImageLayer = styled.div`
  flex: 1;
  display: flex;
  cursor: pointer;

  @media ${({ theme }) => theme.device.mobile}{
    overflow: hidden;
  }
`;

export const Image = styled(GatsbyImage)`
  max-height: 85vh;
  width: auto;
  margin: auto;
  display: none;
  transition: opacity 1s ease-in-out;
  
  @media ${({ theme }) => theme.device.mobile}{
    min-height: 320px;

    ${props => props.correction && props.correction === "1" && css`
      margin-right: -80px;
    `};

    ${props => props.correction && props.correction === "2" && css`
      margin-right: -140px;
    `};

    ${props => props.correction && props.correction === "5" && css`
      margin-right: -110px;
    `};
  }

  ${props => props.activeimage && props.activeimage === "true" && css`
    opacity: 1;
    pointer-events: auto;
    display: block;
  `};
`;
